import { Bus } from '@atlas/core';

const parentWindow = window.parent;
const source = 'iframe-application';

export const sendPostMessage = (action, payload) => {
  try {
    const message = { action, payload, source };
    parentWindow.postMessage(message, '*');
  } catch (err) {
    console.error('Unable to send post message', err);
  }
};

const bindEventToPostMessage = eventName => {
  const handler = payload => sendPostMessage(eventName, payload);

  Bus.on(eventName, handler);
};

// Special iframe events
bindEventToPostMessage('ui:viewport');
bindEventToPostMessage('ui:content_height');
bindEventToPostMessage('ui:device');
bindEventToPostMessage('router:change_location');

// Notifications
bindEventToPostMessage(Bus.events.notification.message);

// Betslip snapshots (on change) events
bindEventToPostMessage(`betslip:main:${Bus.events.bet.snapshot}`);
bindEventToPostMessage(`betslip:edit:${Bus.events.bet.snapshot}`);
bindEventToPostMessage(`betslip:quick:${Bus.events.bet.snapshot}`);
bindEventToPostMessage(Bus.events.bet.snapshot);

// Betslip place bet results event
bindEventToPostMessage(Bus.events.bet.placedSuccess);
bindEventToPostMessage(Bus.events.bet.placedFail);

// Betslip validation
bindEventToPostMessage(Bus.events.bet.validationSuccess);
bindEventToPostMessage(Bus.events.bet.validationError);

// Order bet
bindEventToPostMessage(Bus.events.bet.orderSuccess);
bindEventToPostMessage(Bus.events.bet.orderError);

// Book bet
bindEventToPostMessage(Bus.events.bet.bookSuccess);
bindEventToPostMessage(Bus.events.bet.bookError);

// Edit bet
bindEventToPostMessage(Bus.events.bet.editSuccess);
bindEventToPostMessage(Bus.events.bet.editError);

// Cashout
bindEventToPostMessage(Bus.events.history.cashoutSuccess);
bindEventToPostMessage(Bus.events.history.cashoutError);

// Partial cashout
bindEventToPostMessage(Bus.events.history.partialCashoutSuccess);
bindEventToPostMessage(Bus.events.history.partialCashoutError);

// Sport url state
bindEventToPostMessage(Bus.events.sport.urlState);
